import axios from "axios";
import Cookies from "js-cookie";
import { User } from "../context/AuthContext";

interface ApiResponse<T> {
  success: boolean;
  data: T;
  error?: string;
  total?: number;
  totalRevenue?: number;
  message?: string;
  token?: string;
  user?: User;
}

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:5001/api",
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// ✅ Request interceptor — always attach the latest token
api.interceptors.request.use(
  (config) => {
    const cookieToken = Cookies.get("Logintoken");
    const localToken = localStorage.getItem("token");
    const token = localToken || cookieToken;

      config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Response interceptor — handle 401 for admin routes
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error.config?.url || "";
    const isAdminRoute =
      url.includes("/admin") ||
      url.includes("/menu") ||
      url.includes("/orders") ||
      url.includes("/loyalty")||
      url.includes("/updation");
    const isLoginRoute = url.includes("/admin/login");

    if (error.response?.status === 401 && isAdminRoute && !isLoginRoute) {
      localStorage.removeItem("token");
      window.location.href = "/admin/login";
    }

    return Promise.reject(error);
  }
);

export type { ApiResponse };
export default api;
